import { SVGProps } from 'react';

const Checkout = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M3 20h3.13v-8.8H3zm16.435-4H12.39l-1.635-.584.258-.752 1.377.536h3.13v-1.6l-6.284-2.4H6.913V18l6.26 2 6.262-2.4zM19.933 6.133h-4.456A3.2 3.2 0 0 0 12.463 4 3.203 3.203 0 0 0 9.26 7.2c0 1.765 1.435 3.2 3.202 3.2 1.392 0 2.577-.89 3.014-2.133h.187l1.067 1.066 1.067-1.066 1.068 1.066L21 7.18zM12.463 8.8c-.881 0-1.601-.72-1.601-1.6s.72-1.6 1.6-1.6 1.601.72 1.601 1.6-.72 1.6-1.6 1.6"
    />
  </svg>
);
export default Checkout;
